/** Pair a phone with this computer (STORY-073): a six-character code and a QR the phone
 * scans on the room network. Used on Room setup and on Settings; the mutation never fails
 * silently (a lost host token, a dead sidecar) and a shown code can be replaced. */
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { newPairing } from "./api";
import { Button, Qr } from "../ui";

export function PairingCard({ className = "", bare = false }: { className?: string; bare?: boolean }) {
  const { t } = useTranslation();
  const pairing = useMutation({ mutationFn: () => newPairing() });
  return (
    <section className={className}>
      {!bare && <h2 className="font-semibold">{t("host.pair")}</h2>}
      <p className="mb-2 text-xs text-[color:var(--ink-2)]">{t("host.pairBody")}</p>
      {pairing.data ? (
        <div className="flex flex-col items-center gap-2">
          {pairing.data.urls[0] && <Qr text={pairing.data.urls[0]} size={180} label={pairing.data.urls[0]} />}
          <p className="bignum text-2xl tracking-widest" translate="no">{pairing.data.code}</p>
          <p className="text-xs text-[color:var(--ink-2)]">{t("host.pairExpires", { min: Math.round(pairing.data.expires_in / 60) })}</p>
          <Button variant="tertiary" loading={pairing.isPending} onClick={() => pairing.mutate()}>{t("host.pairAgain")}</Button>
        </div>
      ) : (
        <>
          {pairing.isError && <p role="alert" className="mb-2 text-sm text-[color:var(--danger)]">{t("host.pairFailed")}</p>}
          <Button variant="secondary" loading={pairing.isPending} onClick={() => pairing.mutate()}>{t("host.pairCta")}</Button>
        </>
      )}
    </section>
  );
}
